import operationTypesList from "./operation-types.list";

export const OperationTypeStores = {
    list: operationTypesList
};